import { SettingsPageLayout } from "../components/SettingsPageLayout";
import CurrencyInput from "../components/CurrencyInput";
import { useLiabilitiesLogic } from "./Liabilities.logic";
import { useNavigate } from "react-router-dom";

/**
 * Liabilities page - Mobile implementation
 * Full-screen form with swipe navigation (< 768px)
 */
function LiabilitiesMobile() {
  const navigate = useNavigate();
  const { formData, loading, handleChange, handleBlur, totalLiabilities } =
    useLiabilitiesLogic();

  return (
    <SettingsPageLayout
      title="Liabilities"
      category="liabilities"
      loading={loading}
      onBack={() => navigate("/settings")}
    >
      <form className="form-page-container">
        <div className="form-page-grid">
          <CurrencyInput
            name="mortgage"
            value={formData.mortgage}
            onChange={handleChange}
            onBlur={handleBlur}
            label="Mortgage"
            helpText="Outstanding mortgage balance"
          />

          <CurrencyInput
            name="creditCardBalance"
            value={formData.creditCardBalance}
            onChange={handleChange}
            onBlur={handleBlur}
            label="Credit Card Balance"
          />

          <CurrencyInput
            name="carLoan"
            value={formData.carLoan}
            onChange={handleChange}
            onBlur={handleBlur}
            label="Car Loan"
          />

          <CurrencyInput
            name="otherLiabilities"
            value={formData.otherLiabilities}
            onChange={handleChange}
            onBlur={handleBlur}
            label="Other Liabilities"
            helpText="Personal loans, student loans, etc."
          />
        </div>
      </form>

      {/* Total (calculated, read-only) - Fixed at bottom on mobile */}
      <div className="form-page-total-bar">
        <div className="form-page-total-row">
          <span className="form-page-total-label">Total Liabilities</span>
          <span id="total" className="form-page-total-value-red">
            ${totalLiabilities.toLocaleString()}
          </span>
        </div>
      </div>
    </SettingsPageLayout>
  );
}

export default LiabilitiesMobile;
